
export default {
  name: 'spinner',
  props: ['message', 'margin'],
  computed: {
    customMargin: function() {
      if (!this.margin) return
      return 'margin: ' + this.margin
    }
  },
}
